import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="brand">
              <svg className="brand__mark" viewBox="0 0 28 28" fill="none" aria-hidden="true">
                <rect x="6.5" y="3.5" width="15" height="19" rx="2.2" fill="#F5F8F9" stroke="#103049" strokeWidth="1.6" />
                <rect x="3.5" y="6.5" width="15" height="19" rx="2.2" fill="#103049" />
                <path d="M7.4 12.2h7.2M7.4 15.6h7.2M7.4 19h4.4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
              <span className="brand__name">Docket</span>
              <span className="brand__by">by Devnco</span>
            </div>
            <p>Trained on your documents. Trusted with your data.</p>
          </div>
          <div className="footer__col">
            <h4>Product</h4>
            <Link to="/platform">Platform</Link>
            <Link to="/how-it-works">How it works</Link>
            <Link to="/security">Security</Link>
          </div>
          <div className="footer__col">
            <h4>Company</h4>
            <Link to="/about">About Devnco</Link>
            <Link to="/industries">Industries</Link>
            <Link to="/insights">Insights</Link>
            <Link to="/contact">Request a pilot</Link>
          </div>
          <div className="footer__col">
            <h4>Contact</h4>
            <a href="mailto:hello@devnco.in">hello@devnco.in</a>
            <Link to="/contact">Book a pilot</Link>
            <Link to="/">Home</Link>
          </div>
        </div>
        <div className="footer__bot">
          <p>© 2026 Devnco Technologies Pvt. Ltd. All rights reserved.</p>
          <span className="url">docketidp.com</span>
        </div>
      </div>
    </footer>
  );
}
